import { createStoreCreator } from 'lib/store'
import reducer from 'workspace/reducers'

export default createStoreCreator(reducer)
